<template>
    <u-dialog-underline-tile v-model="shows" v-bind="$attrs">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-dialog-underline-tile>
</template>

<script>
import UDialogUnderlineTile from "@/components/publish/styles/dialogs/u-dialog-underline-tile.vue";

export default {
    props: {},
    components: {
        UDialogUnderlineTile,
    },
    data() {
        return {
            shows: false,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
